module.exports = __webpack_public_path__ + "img/continent.409.40f7976c.png";